<template>
  <div>
    <h3>Rayon</h3>
    <div v-for="{ radius, stats } in statItems" :key="radius">
      <h4>{{ radius }} km</h4>
      <stats-list :items="stats" />
    </div>
  </div>
</template>

<script>
import StatsList from '@/components/stats-list'
export default {
  components: {
    StatsList
  },
  props: {
    statItems: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style lang="scss" scoped></style>
